<template>
  <sidebar-item-body class="pc-note__catalog" name="catalog">
    <div class="pc-loading" v-if="isLoading">
      <i class="el-icon-loading"></i>
      <span>加载中...</span>
    </div>
    <catalog-item v-else :data="catalog"/>
  </sidebar-item-body>
</template>

<script>
import { mapGetters } from 'vuex'
import CatalogItem from '@/components/note/sidebar/CatalogItem.vue'
import SidebarItemBody from '@/components/note/sidebar/SidebarItemBody.vue'

export default {
  components: {
    CatalogItem,
    SidebarItemBody
  },
  computed: {
    ...mapGetters('workbench/current', {
      catalog: 'notebookCatalog',
      isLoading: 'notebookLoading'
    })
  }
}
</script>
